import { isEmpty } from 'ramda';

export const getFieldName = (item, customFieldValue = false) => (
    `${item.xmlTblName}#${customFieldValue ? item.customFieldValue || `${item.xmlName}_OTHER` : item.xmlName}`
);

export const notEmpty = (value) => value && !isEmpty(value);
